import React from 'react';
import {Name, Pill, Row } from './styles';


export interface SubRowProps {
    name: string;
    value: string | React.ReactNode;
}

export const SubRow: React.VFC<SubRowProps> = ({
    name,
    value
}) => {
    return (
        <Row>
            <Pill />
            <Name>{name}</Name>
            <b>{value}</b>
        </Row>
    );
};